import intl from 'react-intl-universal';
import Grid from '@mui/material/Grid2';
import { Box, Button, Typography } from '@mui/material';
import { getIssueStatus } from 'shared/constants/issues';
import { getUserFullName } from 'utils/name';
import { Status } from 'components/Status/styles';
import State from 'components/DataTable/State';

export const getSelectedIssuesListTitle = () => {
  return (
    <Grid container spacing={2} key={0}>
      <Grid size={1}></Grid>
      <Grid size={2}>
        <Typography variant="body2" style={{ marginTop: '25px' }}>
          {intl.get('upload_mission_menu_item_issue_title')}
        </Typography>
      </Grid>
      <Grid size={2}>
        <Typography variant="body2" style={{ marginTop: '25px' }}>
          {intl.get('case_list_label_column_status')}
        </Typography>
      </Grid>
      <Grid size={2}>
        <Typography variant="body2" style={{ marginTop: '25px' }}>
          {intl.get('case_list_label_column_state')}
        </Typography>
      </Grid>
      <Grid size={3}>
        <Typography variant="body2" style={{ marginTop: '25px' }}>
          {intl.get('case_list_label_column_doctor_in_charge')}
        </Typography>
      </Grid>
      <Grid size={2}>
        <Typography variant="body2" style={{ marginTop: '25px' }}>
          {intl.get('case_list_label_column_details')}
        </Typography>
      </Grid>
    </Grid>
  );
};

const getDoctorNamesString = (doctors, issue) => {
  const doctorsInCharge = doctors.filter((user) =>
    issue.userIds.includes(user.id)
  );
  var doctorList = [];
  for (var index = 0; index < doctorsInCharge.length; index++) {
    const doctor = doctorsInCharge[index];
    doctorList.push(getUserFullName(doctor.firstName, doctor.lastName));
  }

  // given doctorList as a array of doctor name strings;
  let doctorNamesString = intl.get('case_list_value_doctor_unassigned');
  if (doctorList.length > 0) {
    doctorNamesString = doctorList[0];
    for (var idx = 1; idx < doctorList.length; idx++) {
      doctorNamesString += '; ' + doctorList[idx];
    }
  }
  return doctorNamesString;
};

export const getSelectedIssuesList = (
  doctors,
  selectedIssues,
  handleOpenIssueDetails
) =>
  selectedIssues.map((issue, index) => {
    return (
      <Grid container spacing={2} key={index + 1}>
        <Grid size={1}></Grid>
        <Grid size={2}>
          <Typography variant="body2" style={{ marginTop: '25px' }}>
            {issue.title}
          </Typography>
        </Grid>
        <Grid size={2}>
          {/* 依頼進捗 */}
          <Status style={{ marginTop: '25px' }} color={issue.status}>
            {getIssueStatus(issue.status)}
          </Status>
        </Grid>
        <Grid size={2}>
          <Typography
            variant="body2"
            style={{ marginTop: '25px', marginLeft: '10px' }}>
            {/* ステータス */}
            <State state={issue.state} />
          </Typography>
        </Grid>
        <Grid size={3}>
          <Typography
            variant="body2"
            style={{ marginTop: '25px', marginLeft: '10px' }}>
            {/* 担当医師名 */}
            {getDoctorNamesString(doctors, issue)}
          </Typography>
        </Grid>
        <Grid size={2}>
          <Box sx={{ marginTop: '15px', marginLeft: '10px' }}>
            <Button
              variant="contained"
              color="primary"
              sx={{
                color: '#ffffff',
              }}
              onClick={() => {
                handleOpenIssueDetails(issue.id);
              }}>
              {intl.get('case_list_button_view')}
            </Button>
          </Box>
        </Grid>
      </Grid>
    );
  });
